import type React from "react";
import ReactMarkdown from "react-markdown";
import gfm from "remark-gfm";
import "./Notes.scss";
import rehypeRaw from "rehype-raw";
import type { NotesDetails } from "../../../entities/Activity/types";

type Props = {
	activity: NotesDetails;
};

const Notes: React.FC<Props> = ({ activity }) => {
	const prefixClass = "notes-activity";
	let incr = 1;

	const Block = ({ children }: { children: React.ReactNode }) => (
		<div className="custom-block">{children}</div>
	);

	const CustomOl = ({ children }: { children: React.ReactNode }) => {
		const i = incr++;
		return (
			<ol className="custom-ol">
				<span className="custom-ol-dot">{i}</span>
				{children}
			</ol>
		);
	};

	return (
		<div className={prefixClass}>
			<div>
				{
					<ReactMarkdown
						remarkPlugins={[gfm]}
						// biome-ignore lint/suspicious/noExplicitAny: <no native type available>
						rehypePlugins={[rehypeRaw as any]}
						className="react-markdown"
						components={{
							ol: CustomOl,
							blockquote: Block,
						}}
					>
						{activity.notes}
					</ReactMarkdown>
				}
			</div>
		</div>
	);
};

export default Notes;
